import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ComponentsModule,
  httpLoaderFactory,
} from 'src/app/components/components.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { StreappersComponent } from './streappers/streappers.component';
import { StreapperCardComponent } from './streapper-card/streapper-card.component';
import { StreapperDetailComponent } from './streapper-detail/streapper-detail.component';

@NgModule({
  declarations: [
    StreappersComponent,
    StreapperCardComponent,
    StreapperDetailComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [TranslateModule],
})
export class StreapperModule {}
